var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuide = function SvgGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.375 2.375h16.25v20H5.375v-20Zm1.25 1.25v17.5h13.75v-17.5H6.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 6.125h10.25v6.5H8.375v-6.5Zm1.25 1.25v4h7.75v-4h-7.75ZM3.125 5.375h3.5v3.5h-3.5v-3.5Zm1.25 1.25v1h1v-1h-1ZM3.125 10.625h3.5v3.5h-3.5v-3.5Zm1.25 1.25v1h1v-1h-1ZM3.125 15.875h3.5v3.5h-3.5v-3.5Zm1.25 1.25v1h1v-1h-1Z",
    fill: "currentColor"
  })));
};
export default SvgGuide;